/**
 * 修改密码全局弹窗事件桥
 *
 * service.js 是非 React 工具层，不能直接依赖 React 组件；
 * 这里提供一个轻量事件桥，让请求层在发现 force_update_password === '0' 时，
 * 可以通知全局 PasswordUpdateModalProvider 打开强制修改密码弹窗。
 */

let passwordUpdateHandler = null;

/** 注册全局修改密码弹窗处理器，返回取消注册函数 */
export function registerPasswordUpdateHandler(handler) {
  passwordUpdateHandler = handler;
  return () => {
    if (passwordUpdateHandler === handler) {
      passwordUpdateHandler = null;
    }
  };
}

/** 请求打开修改密码弹窗 */
export function requestPasswordUpdate(options = {}) {
  if (passwordUpdateHandler) {
    passwordUpdateHandler(options);
  }
}
